import type { ChamadoKanban } from "../../../types/api";
import type { ChamadoGestao } from "../../../types/portalCliente";

/** Sem acento e sem caixa: "Manutenção" e "manutencao" são a mesma busca. */
export const normalizar = (texto: string): string =>
  texto.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();

/**
 * Cada palavra digitada precisa aparecer, em qualquer ordem. A origem exigia a
 * frase inteira, e "erro boleto" não achava "Erro ao emitir boleto".
 */
const filtrarPorTermos = <T,>(itens: T[], busca: string, textoDe: (item: T) => string): T[] => {
  const termos = normalizar(busca).split(/\s+/).filter(Boolean);
  if (termos.length === 0) return itens;
  return itens.filter((item) => {
    const texto = normalizar(textoDe(item));
    return termos.every((termo) => texto.includes(termo));
  });
};

/** O que a busca olha, os mesmos campos da origem: número, assunto, descrição, projeto e tipo. */
export const filtrarPorBusca = (itens: ChamadoGestao[], busca: string): ChamadoGestao[] =>
  filtrarPorTermos(
    itens,
    busca,
    (c) => `#${c.id} ${c.assunto} ${c.descricao ?? ""} ${c.projetoNome ?? ""} ${c.categoriaChamado ?? ""}`
  );

/**
 * A mesma busca no quadro, sobre o que ele já carregou. Antes o texto ia para a
 * API: cada tecla virava consulta nova (a mais cara, com SLA por cartão), a tela
 * voltava ao esqueleto, e o número do chamado nem entrava na pesquisa.
 */
export const filtrarQuadroPorBusca = (itens: ChamadoKanban[], busca: string): ChamadoKanban[] =>
  filtrarPorTermos(
    itens,
    busca,
    (c) => `#${c.id} ${c.assunto} ${c.descricao ?? ""} ${c.projeto ?? ""} ${c.categoria ?? ""}`
  );
